import { TextArea } from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { FormCard } from "../../../components/FormControls/FormCard";

interface ParentNoteFormCardProps {
  value?: string;
  readonly?: boolean;
  onChange?: (value: string) => void;
}

const MAX_LENGTH = 1000;

export function ParentNoteFormCard({
  value = "",
  readonly,
  onChange,
}: ParentNoteFormCardProps) {
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  const exceededMaxLength = value.length > MAX_LENGTH;
  const rowAmount = Math.ceil(value.length / 100);

  return (
    <FormCard cardTitle={t("common.institutionDetails.parentNoteTitle")}>
      <Row>
        <Col md={12}>
          <TextArea
            ariaLabel={t("common.institutionDetails.parentNoteLabel")}
            label={t("common.institutionDetails.parentNoteLabel")}
            value={value}
            readonly={readonly}
            onChange={handleChange}
            rows={rowAmount}
            errorText={
              exceededMaxLength
                ? t("common.institutionDetails.parentNoteError")
                : ""
            }
            helperText={`${value.length} / ${MAX_LENGTH}`}
          />
        </Col>
      </Row>
    </FormCard>
  );
}
